import { Component, Input, OnInit } from '@angular/core';

import { CompanyService } from '../service/company.service';
import { HomeService } from '../service/home.service';

import { version } from '../../version';

@Component({
  selector: 'app-printfooter',
  templateUrl: './printfooter.component.html',
  styleUrls: ['./printfooter.component.css'],
})
export class PrintfooterComponent implements OnInit {
  constructor(private homeService: HomeService, private companyService: CompanyService) {
    this.companyId = localStorage.getItem('companyId');
    this.getCompanyData();
    this.getUserData();
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() count: number;

  // DECLARATION OF ALL VARIABLES
  companyId: string;

  companyName: string;

  firstname: string;

  phone: number;

  email: string;

  address: string;

  today = new Date();

  version: string;

  ngOnInit() {
    this.version = version;
  }

  // GET USERS DATA FROM USER TABLE TO SHOW DETAIL OF USER THE IN FOOTER
  getUserData() {
    this.homeService.getUser().subscribe(
      (users) => {
        let userObj = this.homeService.userInfo;
        userObj = users.data;
        this.firstname = `${
          userObj.firstname[0].toUpperCase() + userObj.firstname.slice(1)
        } ${userObj.lastname[0].toUpperCase()}${userObj.lastname.slice(1)}`;
        this.email = userObj.email;
        this.phone = userObj.phone;
        this.address = `${userObj.address1} ${userObj.address2}`;
      },
      (err) => {}
    );
  }

  // GET COMPANY NAME FROM COMPANY TABLE(DB)
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyName = res.data[0].companyname;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/printfooter/printfooter.component.ts